import angular from 'angular';
import * as rotulos from '../../bureaus.rotulos';
import { IBureauTenantResumo } from '../../models/bureaus.model';
import { IMeurhBureausEquipesModalParams } from './bureaus-equipes.modal.service';
import { MeurhBureausEquipesService } from '../../bureaus-equipes.service';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export class MeurhBureausEquipesModalController implements angular.IController {
    static $inject = ['params', '$uibModalInstance', 'MeurhBureausEquipesService', 'NewToaster'];

    public form: angular.IFormController;
    public email = '';
    public tenantId: number | null = null;
    public tenantsSelecionados: number[] = [];
    public busy = false;

    constructor(
        public params: IMeurhBureausEquipesModalParams,
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        private meurhBureausEquipesService: MeurhBureausEquipesService,
        private NewToaster: any,
    ) {
        if (!params.tenantPorId && params.tenantsLimite.length === 1) {
            this.tenantsSelecionados = [params.tenantsLimite[0].tenant];
        }
    }

    public titulo(): string {
        return this.ehAdministrador() ? 'Adicionar administrador de equipe' : 'Adicionar membro de equipe';
    }

    public rotuloTenant(tenant: IBureauTenantResumo): string {
        return tenant ? rotulos.rotuloTenant(tenant) : '';
    }

    public emailValido(): boolean {
        return EMAIL_REGEX.test((this.email || '').trim());
    }

    public tenantIdValido(): boolean {
        return this.tenantIdInformado() !== null;
    }

    public salvar(): void {
        const tenantsValidos = this.params.tenantPorId
            ? this.tenantIdValido()
            : this.tenantsSelecionados.length > 0;

        if (!this.emailValido() || !tenantsValidos) {
            return;
        }

        const email = this.email.trim();
        this.busy = true;

        const request: angular.IPromise<any> = this.ehAdministrador()
            ? this.meurhBureausEquipesService.createAdministrador(email, this.tenantIdInformado())
            : this.meurhBureausEquipesService.createMembro(
                email,
                this.params.tenantPorId ? [this.tenantIdInformado()] : this.tenantsSelecionados
            );

        request
            .then((resultado) => {
                this.NewToaster.pop({
                    type: 'success',
                    title: this.ehAdministrador()
                        ? 'Administrador de equipe adicionado com sucesso!'
                        : 'Membro de equipe adicionado com sucesso!'
                });

                this.$uibModalInstance.close(resultado);
            })
            .catch((error) => {
                this.NewToaster.pop({
                    type: 'error',
                    title: this.ehAdministrador()
                        ? 'Erro ao adicionar administrador'
                        : 'Erro ao adicionar membro',
                    body: error?.data?.message || (this.ehAdministrador()
                        ? 'Ocorreu um erro ao adicionar o administrador de equipe.'
                        : 'Ocorreu um erro ao adicionar o membro de equipe.')
                });
            })
            .finally(() => {
                this.busy = false;
            });
    }

    public cancelar(): void {
        this.$uibModalInstance.dismiss('cancel');
    }

    private ehAdministrador(): boolean {
        return this.params.tipo === 'administrador';
    }

    /** O backend valida `tenant_id` com `is_int()`, então só um inteiro positivo pode ser enviado. */
    private tenantIdInformado(): number | null {
        const valor: any = this.tenantId;

        if (valor === null || valor === undefined || valor === '') {
            return null;
        }

        const tenantId = parseInt(valor, 10);

        return Number.isInteger(tenantId) && tenantId > 0 ? tenantId : null;
    }
}
